export default {
  // Page titles
  title: 'มิเตอร์',
  meter_readings: 'ค่ามิเตอร์',
  bulk_readings: 'บันทึกมิเตอร์',

  // EP-58 T5 — บัญชีคอนโดมิเนียมไม่ใช้มิเตอร์ในระดับห้อง
  not_applicable_condo_title: 'คอนโดมิเนียมไม่มีการบันทึกค่ามิเตอร์ต่อห้อง',
  not_applicable_condo_body:
    'คอนโดมิเนียมใช้มิเตอร์รวมในระดับอาคาร ค่าใช้จ่ายต่อเนื่องคิดผ่านค่าส่วนกลางแทน',

  // Descriptions
  description: 'ติดตามค่ามิเตอร์สาธารณูปโภค',
  bulk_description: 'บันทึกค่ามิเตอร์หลายตัวพร้อมกัน',
  bulk_record_description: 'บันทึกค่ามิเตอร์ {{type}} สำหรับ {{property}}',

  // Labels
  labels: {
    // Appended to a bulk-readings room type heading when the room type has a
    // floor. A floor already written with its own word ("ชั้น3") is shown as is.
    floor_value: 'ชั้น {{floor}}',
    meter: 'มิเตอร์',
    meter_type: 'ประเภทมิเตอร์',
    used_in_invoices: 'ใช้ในใบแจ้งหนี้แล้ว',
    serial_number: 'หมายเลขเครื่อง',
    serial_number_optional: 'หมายเลขเครื่อง (ไม่บังคับ)',
    latest_reading: 'ค่าล่าสุด',
    latest: 'ล่าสุด',
    latest_usage: 'การใช้งานล่าสุด',
    previous_reading: 'ค่าก่อนหน้า',
    current_reading: 'ค่าปัจจุบัน',
    reading_date: 'วันที่บันทึก',
    reading_month: 'เดือนที่บันทึก',
    reading_value: 'ค่าที่อ่านได้',
    usage: 'การใช้งาน',
    photo: 'รูปภาพ',
    reading_history: 'ประวัติการบันทึก',
    billing_day: 'วันออกบิล: {{day}}',
    unit: 'ห้อง',
    serial_no: 'หมายเลขเครื่อง',
    previous: 'ก่อนหน้า',
    current: 'ปัจจุบัน',
    meter_type_label: 'ประเภทมิเตอร์:',
    reading_month_label: 'เดือนที่บันทึก:',
  },

  // Placeholders
  placeholders: {
    serial_number: 'เช่น WM-001',
    previous_value: 'ค่ามิเตอร์ก่อนหน้า',
    current_value: 'ค่ามิเตอร์ปัจจุบัน',
  },

  // Meter types
  types: {
    water: 'น้ำ',
    electricity: 'ไฟฟ้า',
  },

  // Bulk readings
  bulk: {
    title: 'บันทึกมิเตอร์',
    property_label: 'อสังหาริมทรัพย์',
    select_property: 'เลือกอสังหาริมทรัพย์',
    reading_date: 'วันที่บันทึก',
    previous: 'ก่อนหน้า',
    current: 'ปัจจุบัน',
    save_all: 'บันทึกทั้งหมด',
    save_readings: 'บันทึกค่ามิเตอร์',
    skip_unchanged: 'ข้ามที่ไม่เปลี่ยนแปลง',
    confirm_title: 'ยืนยันการบันทึกการอ่านมิเตอร์',
    confirm_summary: 'จะสร้าง {{created}} รายการ และแก้ไข {{edited}} รายการ',
    more_rows: '+{{n}} รายการเพิ่มเติม',
  },

  rollover: {
    check_on_save: 'กดบันทึกเพื่อตรวจสอบและยืนยันหน่วยใช้เมื่อมิเตอร์ย้อนรอบ',
    badge: 'ย้อนรอบ {{usage}} หน่วย',
    confirm: 'ยืนยันว่าเลขนี้ถูกต้อง (มิเตอร์ย้อนรอบ)',
    unconfirmed_skipped: 'รายการมิเตอร์ย้อนรอบที่ยังไม่ยืนยันจะไม่ถูกบันทึก',
    needs_confirmation: 'กรุณาตรวจสอบและยืนยันรายการมิเตอร์ย้อนรอบก่อนบันทึกอีกครั้ง',
  },

  // Actions
  actions: {
    add_meter: 'เพิ่มมิเตอร์',
    edit_meter: 'แก้ไขมิเตอร์',
    delete_meter: 'ลบมิเตอร์',
    add_reading: 'บันทึกค่ามิเตอร์',
    edit_reading: 'แก้ไขการอ่านมิเตอร์',
    save_reading: 'บันทึก',
    view_photos: 'ดูรูปภาพ',
    record_short: 'บันทึก',
  },

  // Empty states
  empty: {
    no_meters: 'ไม่มีมิเตอร์',
    no_meters_description: 'เพิ่มมิเตอร์เพื่อติดตามการใช้งานสาธารณูปโภค',
    no_readings: 'ไม่มีการบันทึก',
    no_readings_description: 'เริ่มบันทึกค่ามิเตอร์เพื่อติดตามการใช้งาน',
    need_two_readings: 'ต้องมีการบันทึกอย่างน้อย 2 ครั้ง',
    no_serial_number: 'ไม่มีหมายเลขเครื่อง',
    no_type_meters: 'ไม่พบมิเตอร์{{type}}',
    no_type_meters_cta: 'เพิ่มมิเตอร์ให้ห้องเพื่อเริ่มบันทึกค่ามิเตอร์',
  },

  // B-057 — inline meter provisioning from the readings page
  add_meter_modal: {
    title: 'เพิ่มมิเตอร์{{type}}',
    description: 'เลือกห้องที่ยังไม่มีมิเตอร์{{type}} เมื่อเพิ่มแล้วจะบันทึกค่ามิเตอร์ได้',
    add_for_type: 'เพิ่มมิเตอร์{{type}}',
    added: 'เพิ่มมิเตอร์{{type}}แล้ว',
    error: 'ไม่สามารถเพิ่มมิเตอร์{{type}}ได้',
    all_have_meters: 'ทุกห้องมีมิเตอร์{{type}}แล้ว',
    no_units: 'อสังหาริมทรัพย์นี้ยังไม่มีห้อง กรุณาเพิ่มห้องก่อน แล้วจึงกลับมาเพิ่มมิเตอร์',
    more_units_hint: 'แสดงห้องหน้าแรก ห้องที่มีอยู่ด้านบนถูกแยกออกแล้ว',
    open: 'เพิ่มมิเตอร์',
  },

  // Setup guide (unit detail - meters section)
  setup_guide: {
    title: 'ตั้งค่ามิเตอร์สำหรับห้องนี้',
    description:
      'มิเตอร์ติดตามการใช้น้ำและไฟฟ้าสำหรับการเรียกเก็บเงิน เพิ่มมิเตอร์เพื่อเริ่มบันทึกค่า',
    step_1_title: 'เพิ่มมิเตอร์น้ำ',
    step_1_description: 'ติดตามการใช้น้ำพร้อมหมายเลขเครื่อง (ไม่บังคับ) เพื่อระบุตัวตน',
    step_2_title: 'เพิ่มมิเตอร์ไฟฟ้า',
    step_2_description: 'ติดตามการใช้ไฟฟ้าเพื่อคำนวณค่าใช้จ่ายแต่ละเดือน',
    step_3_title: 'บันทึกค่าผ่านบันทึกมิเตอร์รวม',
    step_3_description:
      'ไปที่หน้าอสังหาริมทรัพย์แล้วใช้บันทึกมิเตอร์เพื่อบันทึกค่ามิเตอร์ทุกห้องพร้อมกัน จัดกลุ่มตามประเภทห้อง',
  },

  // Photo
  photo: {
    title: 'รูปมิเตอร์',
    evidence: 'รูปถ่ายหลักฐาน (ไม่บังคับ)',
    hint: 'ถ่ายรูปมิเตอร์',
    reading_photo_alt: 'รูปมิเตอร์ที่ {{count}}',
  },

  // Validation
  validation: {
    meter_type_required: 'กรุณาเลือกประเภทมิเตอร์',
  },

  // List page (sidebar landing at /meter-readings)
  list_page: {
    title: 'ค่ามิเตอร์',
    description: 'ดูและบันทึกค่ามิเตอร์สำหรับอสังหาริมทรัพย์ของคุณ',
    select_property: 'เลือกอสังหาริมทรัพย์',
    all_properties: 'ทุกอาคาร',
    empty_title: 'ไม่พบมิเตอร์',
    empty_description: 'อสังหาริมทรัพย์นี้ยังไม่มีการตั้งค่ามิเตอร์',
    needs_entry: 'รอบันทึก',
    recorded: 'บันทึกแล้ว',
    water_section: 'น้ำ',
    electricity_section: 'ไฟฟ้า',
    no_property_selected: 'เลือกอสังหาริมทรัพย์เพื่อดูมิเตอร์',
  },

  // Meters section in unit creation form
  section: {
    title: 'มิเตอร์',
    toggle_label: 'เพิ่มมิเตอร์ให้ห้องนี้',
    water: 'มิเตอร์น้ำ',
    electricity: 'มิเตอร์ไฟฟ้า',
    serial_optional: 'หมายเลขเครื่อง (ถ้ามี)',
    opening_reading_placeholder: 'ค่ามิเตอร์ปัจจุบัน',
    opening_reading_hint: 'กรอกค่าที่แสดงบนมิเตอร์ตอนนี้ ระบบจะใช้เป็นค่าตั้งต้น เดือนถัดไปจะคิดเงินจากส่วนต่างของค่ามิเตอร์',
  },

  // Unit readings form (wizard step 6 / single-unit reading surface)
  unit_readings: {
    title: 'บันทึกค่ามิเตอร์',
    save: 'บันทึกค่ามิเตอร์',
    consumption_this_month: 'การใช้งานเดือนนี้: {{count}} หน่วย',
    no_meters: 'ยังไม่มีมิเตอร์ที่ตั้งค่าสำหรับห้องนี้',
    saved: 'บันทึกค่ามิเตอร์สำเร็จ',
    error_prefix: '{{meter}}: {{message}}',
  },

  // Messages
  messages: {
    unit_created_meter_failed: 'สร้างห้องสำเร็จ แต่ตั้งค่ามิเตอร์{{meter_type}}ไม่สำเร็จ: {{error}}',
    delete_title: 'ลบการบันทึก',
    delete_confirm: 'ลบการบันทึกนี้? การกระทำนี้ไม่สามารถยกเลิกได้',
    delete_meter_confirm: 'ลบมิเตอร์นี้? การกระทำนี้ไม่สามารถยกเลิกได้',
    created: 'บันทึกค่ามิเตอร์สำเร็จ',
    updated: 'แก้ไขค่ามิเตอร์สำเร็จ',
    deleted: 'ลบการบันทึกสำเร็จ',
    bulk_saved: 'บันทึกค่ามิเตอร์ทั้งหมดสำเร็จ',
    readings_saved: 'บันทึก {{count}} รายการสำเร็จ',
    no_changes: 'ไม่มีการเปลี่ยนแปลงที่ต้องบันทึก',
    save_failed: 'บันทึกค่ามิเตอร์ไม่สำเร็จ',
    // Legacy single-shot lock message — เก็บไว้เผื่อ surface เก่ายังใช้
    invoice_locked: 'ห้อง {{units}} ถูกล็อกเพราะมีใบแจ้งหนี้แล้ว กดไอคอน "แก้ไขรายตัว" (✏️) ที่ปลายแถวเพื่อแก้ค่ามิเตอร์ทีละตัว',
    all_properties_read_only_hint: 'มุมมองแบบทุกอสังหาริมทรัพย์ใช้สำหรับดูเท่านั้น เลือกอสังหาริมทรัพย์จากด้านบนเพื่อบันทึก/แก้ไขค่ามิเตอร์',
    edit_individually: 'แก้ไขรายตัว',
    not_found: 'ไม่พบมิเตอร์',
    partial_failures_one: '{{count}} อสังหาริมทรัพย์โหลดไม่สำเร็จ แสดงรายการที่โหลดได้ด้านล่าง',
    partial_failures_other: '{{count}} อสังหาริมทรัพย์โหลดไม่สำเร็จ แสดงรายการที่โหลดได้ด้านล่าง',

    // Partial-success bulk save (server ส่ง 200 พร้อม array saved / locked /
    // no_op / cascade_blocked — ดู BulkSaveResult ใน useBulkReadings).
    partial_save_summary_title: 'การบันทึกบางรายการต้องตรวจสอบเพิ่ม',
    partial_save_summary_body: 'บันทึก {{saved}} รายการสำเร็จ มี {{locked}} รายการถูกล็อกเพราะมีใบแจ้งหนี้แล้ว',
    no_op_skipped_one: 'ข้าม {{count}} รายการ ค่าตรงกับที่บันทึกไว้แล้ว',
    no_op_skipped_other: 'ข้าม {{count}} รายการ ค่าตรงกับที่บันทึกไว้แล้ว',
    invoice_locked_title: 'ถูกล็อกเพราะมีใบแจ้งหนี้',
    locked_inline_edit_cta: 'แก้ไขรายตัว',
    cascade_blocked_warning_one: '{{count}} รายการไม่ถูกบันทึก เพราะการแก้ไขจะทำให้ค่าการใช้งานของใบแจ้งหนี้เดือนถัดไปที่ออกแล้วเสียหาย เปิดมิเตอร์ที่ได้รับผลกระทบเพื่อแก้ไขรายตัว',
    cascade_blocked_warning_other: '{{count}} รายการไม่ถูกบันทึก เพราะการแก้ไขจะทำให้ค่าการใช้งานของใบแจ้งหนี้เดือนถัดไปที่ออกแล้วเสียหาย เปิดมิเตอร์ที่ได้รับผลกระทบเพื่อแก้ไขรายตัว',
  },
}
